/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * (C) Copyright IBM Corp. 2017, 2021
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define({
		"rtl": "De derecha a izquierda",
		"timeZoneID": "Huso horario",
		"skin": "Estilo",
		"metricsFileImportTask": "Nueva importación desde archivos",
		"displayMode": "Vista predeterminada",
		"credentialRenewed": "Las credenciales se han renovado con el ID de usuario y la contraseña actuales.",
		"productLocale": "Idioma del producto",
		"toggleDisabled": "desactivar",
		"credentialChange": "Renovar",
		"log_level_Debug": "Depuración",
		"confirmNewPassword": "Confirmar nueva contraseña",
		"unsavedViewMsg2": "Se perderán los cambios si antes no los guarda.",
		"supportPortalErrorMessage": "Inténtelo de nuevo.  Si el problema continúa, póngase en contacto con el administrador.",
		"legalText": "Materiales bajo licencia - Propiedad de IBM Corp. © Copyright IBM Corporation y otro(s) 2005, %{year}. IBM, el logotipo de IBM, ibm.com y Cognos son marcas registradas de International Business Machines Corp., registradas en varias jurisdicciones de todo el mundo. Hay disponible una lista actual de marcas registradas de IBM en la web en www.ibm.com/legal/copytrade.shtml. La licencia de este Programa se concede de acuerdo con los términos del acuerdo de licencia que lo acompaña. Este acuerdo de licencia puede estar ubicado en una biblioteca o carpeta de directorio del Programa identificada como \"License\" o \"Non_IBM_License\", si procede, o suministrarse como acuerdo de licencia impreso. Lea detenidamente el acuerdo antes de utilizar el Programa. La utilización del programa supone la aceptación de estos términos.",
		"groupsAndRoles": "Grupos y roles",
		"metricsMaintenanceTask": "Nuevo mantenimiento",
		"email": "Correo electrónico",
		"contextual": "Contextual",
		"resetHome": "Restablecer al valor predeterminado",
		"ltr": "De izquierda a derecha",
		"credentials": "Credenciales",
		"logging_congfig_title": "Registro",
		"changePasswordTitle": "Cambiar la contraseña",
		"format": "Formato de informe",
		"showUnread": "Mostrar no leído",
		"AILearning_active": "El aprendizaje de AI está activo:",
		"docsErrorMessage": "Inténtelo de nuevo.  Si el problema continúa, póngase en contacto con el administrador.",
		"toggleEnabled": "activar",
		"homeSetError": "Se ha producido un error al establecer la página de inicio predeterminada; pruebe a cerrar y volver a abrir esta vista.",
		"passwordChange": "Cambiar la contraseña",
		"profile": "Perfil",
		"pdfRestricted": "PDF (Restringido)",
		"drillThrough": "Definiciones de acceso a los detalles",
		"homeSet": "La página principal se ha establecido correctamente",
		"regionalOptions": "Opciones regionales",
		"myPreferences": "Mis preferencias",
		"defaultHome": "Valor predeterminado",
		"version": "Versión",
		"controller": "Controller",
		"manage": "Gestionar",
		"biDirectionalFeaturesEnabled": "Soporte de idioma bidireccional",
		"newFeaturesErrorTitle": "El enlace con las nuevas características no ha funcionado.",
		"passwordMatch": "Coincidencia de contraseña",
		"updateProfileAndsettings": "Actualizar perfil y valores",
		"dashboardConsole": "Espacio de trabajo",
		"legacyAppsSlideoutLabel": "Aplicaciones heredadas disponibles",
		"logging_config_description": "El registro se utiliza para la resolución de problemas. Consulte con su administrador para obtener orientación sobre los valores.",
		"confirmDeletion": "Confirmar supresión",
		"signInButtonText": "Iniciar sesión",
		"dataSourceCredentials": "Credenciales del servidor de datos",
		"AILearningConfigurationSlideoutAllyLabel": "Configuración del aprendizaje de AI",
		"loadingSettings": "Cargando valores",
		"spreadsheetMLRestricted": "Excel (Restringido)",
		"manageAILearning": "Aprendizaje de AI",
		"xlsxDataRestricted": "Datos de Excel (Restringido)",
		"advanced": "Opciones avanzadas",
		"ok": "Aceptar",
		"changeEmail": "Cambio",
		"showHints": "Mostrar sugerencias",
		"general": "General",
		"xlsxData": "Datos de Excel",
		"newPassword": "Contraseña nueva",
		"hideAll": "Ocultar todo",
		"confirmPassword": "Confirmar contraseña",
		"AILearning_config_description": "Mejore las recomendaciones internas del producto permitiendo que Cognos Analytics aprenda acerca de su uso.",
		"metricStudio": "Studio",
		"supportPortalErrorTitle": "El enlace al portal de soporte no ha funcionado",
		"log_level_Warn": "Aviso",
		"contentSettings": "Valores de contenido",
		"setHomeButton": "Conjunto",
		"myCapabilities": "Mis funciones",
		"homePage": "Página principal",
		"helpErrorMessage": "Inténtelo de nuevo.  Si el problema continúa, póngase en contacto con el administrador.",
		"loadingProfile": "Cargando perfil",
		"portal": "Portal",
		"metricsPackage": "Nuevo paquete",
		"myCredentials": "Mis credenciales",
		"credentialCreate": "Crear",
		"eventStudio": "Event Studio",
		"updatePWUnknownError": "No se puede actualizar la contraseña",
		"showHiddenObjects": "Mostrar entradas ocultas",
		"csv": "CSV",
		"docsErrorTitle": "El enlace para la documentación no ha funcionado",
		"log_level_Error": "Error",
		"wrongPassword": "No se puede autenticar",
		"productName": "IBM Cognos Analytics %{version}",
		"log_level_Info": "Información",
		"welcomeBanner": "Banner de bienvenida",
		"helpErrorTitle": "El enlace para la ayuda no ha funcionado.",
		"contentLocale": "Idioma del contenido",
		"pdf": "PDF",
		"oldPassword": "Contraseña anterior",
		"spreadsheetML": "Excel",
		"accessibilityFeatures": "Características de accesibilidad",
		"manageLogging": "Registro",
		"loggingConfigurationSlideoutA11yLabel": "Configuración de registro",
		"communityErrorTitle": "El enlace para la comunidad no ha funcionado.",
		"companionApps": "Aplicaciones complementarias",
		"setHomeLabel": "Establecer inicio como (vista actual)",
		"metricsExportTask": "Nueva exportación",
		"csvRestricted": "CSV (Restringido)",
		"newFeaturesErrorMessage": "Inténtelo de nuevo.  Si el problema continúa, póngase en contacto con el administrador.",
		"contributor": "Contributor",
		"showAll": "Mostrar todo",
		"logging_active": "El registro está activo:",
		"html": "HTML",
		"profileAndSettings": "Perfil y valores",
		"baseTextDirection": "Dirección de base para texto",
		"queryStudio": "Query Studio",
		"metricsManager": "Metrics Manager",
		"password": "Contraseña",
		"invalidEmail": "Escriba una dirección de correo electrónico válida",
		"credentialCreateSuccess": "Se han creado correctamente las credenciales",
		"settings": "Valores",
		"restrictedFormatSelected": "No puede ejecutar informes con este formato, pero puede acceder a los informes guardados en este formato.",
		"usageDataDeletionConfirmation": "Suprimir los datos de uso restablece cualquier aprendizaje de AI.  ¿Está seguro de que desea suprimir los datos de uso?",
		"powerplayStudio": "PowerPlay Studio",
		"viewDetails": "Ver detalles",
		"deleteUsageData": "Suprimir datos de uso:",
		"showPassword": "Mostrar contraseña",
		"AILearning_config_title": "Aprendizaje de AI",
		"myPreferencesSlideoutLabel": "Perfil y valores",
		"passWordChangeSuccess": "Se ha cambiado correctamente la contraseña",
		"logging_level": "Nivel de registro:",
		"analysisStudio": "Analysis Studio",
		"communityErrorMessage": "Inténtelo de nuevo.  Si el problema continúa, póngase en contacto con el administrador.",
		"cancel": "Cancelar",
		"shareSetError": "Esta acción no se puede realizar antes de cerrar y volver a abrir esta vista.",
		"passwordNotMatch": "La contraseña no coincide",
		"xml": "XML",
		"xmlRestricted": "XML (Restringido)",
		"openMenu": "Menú Abrir",
		"closeMenu": 'Menú Cerrar'
});